import getWindow from 'utils/get-window'

export const env = process.env.NODE_ENVIRONMENT || getWindow().__APP_ENV__ || 'development'
export const release = process.env.RAZZLE_RELEASE || require('../../../package.json').version
export const emotionCacheKey = 'bb-comp'

export const eeveeCoreVersion = require('../../../package.json')?.dependencies['@uswitch/ev-core']
export const isDev = env === 'development'
export const isTest = env === 'test'
export const isProd = env === 'production'
export const noVPN = env === 'no_vpn'
export const isMercuryLocal = process.env.RAZZLE_MERCURY_ENVIRONMENT === 'local'
export const environment = env

export default env
